import { BaseBus } from './BaseBus';
import { DateFunctions } from '../static/date-functions';
import { v_InventoryBus } from './v_InventoryBus';
import { v_LocationDetailBus } from './v_LocationDetailBus';
import { CommonFunctions } from '../static/common-functions';
import { CommonValues } from '../static/CommonValues';

/*
 * Part Number: number
 * Summary: inventoryDesc
 * Full Description: fullDescription
 * Quantity: quantity
 * Resource: personName
 * Warehouse: inventoryLocationName
 * Date: addedDate
 * (checkbox)
 */
export class v_DispatchPartBus extends BaseBus
{
    constructor(busObj: v_DispatchPartBus = null) {
        super(busObj);
        this.addedDate = DateFunctions.getDate(this.addedDate);
        this.sageDt = DateFunctions.getDate(this.sageDt);
    }
    CID(): any {
        return this.dispatchPartId;
    }

    setId(id: any) {
        this.dispatchPartId = id;
    }
    setParentId(id: any) {
        this.dispatchId = id;
    }
    setFromForm(busObj: any) {
        super.setFromForm(busObj);
        this.inventoryLocationId = this.inventoryLocationId;
    }
    setNew(userId: any, date: Date, companyId: any = null, personId: any = null, parentId: any = null, other: v_LocationDetailBus = null) {
        this.quantity = 1;
        this.personId = personId;
        this.addedDate = new Date(date);
        this.inventoryLocationId = other.inventoryLocationId;
    }
    get inFinance(): boolean {
        return DateFunctions.isValidDate(this.sageDt);
    }
    setCommon(userId: any, date: Date, companyId: any = null, personId: any = null) {
        if (!DateFunctions.isValidDate(this.insertDt)) {
            this.insertDt = date;
            this.insertUserId = userId;
        }
        this.updateDt = date;
        this.updateUserId = userId;
    }
    changeInventoryItem(data: v_InventoryBus) {
        this.number = data.number;
        this.inventoryDesc = data.inventoryDesc;
        this.inventoryId = data.inventoryId;
        this.fullDescription = data.fullDescription;

        //this.quantity = 1;
        //this.qtyInStock = data..currentCost;
    }
  dispatchPartId: any;
  dispatchId: any;
  personId: any;
  personName: string;
  inventoryLocationXREFId: any;
  quantity: number;
  addedDate: Date;
  inventoryLocationName: String;
  number: String;
  inventoryDesc: String;
  inventoryId: any;
  currentCost: number;
  lastCost: number;
  flatCost: number;
  ratio: number;
  internationalCost: number;
  inventoryLocationId: any;
  warehouse: string;
  qtyInStock: number;
  avgCost: number;
  fullDescription: String;
  sageDt: Date;
  onConstDraw: Boolean;
  insertDt: Date;
  insertUserId: any;
  updateDt: Date;
  updateUserId: any;
}
